export enum EDiscountReason {
  Empty = 'Empty',
  Simple_Clean = 'Simple Clean',
}
